import {isString, kebabCase, startCase} from 'lodash'

export const normalizeMenuItem = (menuItem) => {
  let name, content, path, active = false
  if (isString(menuItem)) {
    name = menuItem
    path = kebabCase(name.toLowerCase())
    content = startCase(name)
  } else {
    name = menuItem.name
    content = menuItem.content || startCase(name)
    path = menuItem.path || kebabCase(name.toLowerCase())
    active = menuItem.active
  }
  return {name, content, path, active}
}


export const normalizeMenuItemPath = (menuItem, options = {}) => {
  const {pathPrefix = ''} = options
  menuItem = normalizeMenuItem(menuItem)
  if (pathPrefix) {
    return `${kebabCase(pathPrefix)}${menuItem.path.indexOf('/') === 0 ? menuItem.path : `/${menuItem.path}`}`
  }
  return menuItem.path
}
